export const VdpId = 'tr-vdp';

export const VdpMarketGuidePath = '/marketguide?';

export const OmpCanvasId = 'canvas-content';
